import SkillView from "./SkillView";

export default SkillView;
